import { Trans, useLingui } from '@lingui/react'
import classNames from 'clsx'
import { type FC } from 'react'

import { TENANT_AT } from 'shared/consts'
import Price from 'views/components/atoms/Price'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'

type Props = {
  totalAmount: number
  currency: string
  totalAmountDiscounts: number
  hasNonPznErx?: boolean
}

const TotalSumBox: FC<Props> = ({
  totalAmount,
  currency,
  totalAmountDiscounts,
  hasNonPznErx,
}) => {
  const { i18n } = useLingui()
  const {
    publicRuntimeConfig: {
      publicConfig: { tenant },
    },
  } = useShopAndRuntimeConfig()

  const savingsText =
    tenant === TENANT_AT ? (
      <TransWithHtml text={i18n._('checkout.verification.totalSavings')} />
    ) : (
      <TransWithHtml text={i18n._('general.cartSumBox.savings')} />
    )

  return (
    <div className="u-margin-large--bottom o-CartSumBox__list-item">
      <div
        className={classNames('l-flex l-flex--distribute-space', {
          'o-CartSumBox__list-item': totalAmountDiscounts,
        })}
      >
        <strong className="a-h2 u-no-margin u-font-weight--bold o-CartSumBox__TotalSumBox__text">
          {hasNonPznErx ? (
            <Trans id="cart.sumBox.erx.sumOfKnownPrices" />
          ) : (
            <Trans id="general.label.totalSum" />
          )}
        </strong>
        <strong className="a-h2 u-no-margin u-font-weight--bold o-CartSumBox__TotalSumBox__text">
          <Price
            amount={totalAmount}
            currency={currency}
            dataQa="cart-sumBox-totalSum"
          />
        </strong>
      </div>
      {Boolean(totalAmountDiscounts) && (
        <div className="l-flex l-flex--distribute-space">
          <span className="u-color--positive u-color-rebranding--positive">
            {savingsText}
          </span>
          <span
            className={classNames({
              'u-color--positive u-color-rebranding--positive':
                Boolean(totalAmountDiscounts),
            })}
          >
            <Price
              amount={totalAmountDiscounts}
              currency={currency}
              dataQa="cart-sumBox-savings"
            />
          </span>
        </div>
      )}
    </div>
  )
}

export default TotalSumBox
